<template>
  <div class="audio-content" v-loading="loading">
    <el-button
      type="primary"
      class="mw-add-button"
      @click="openEditWin('create')"
      >添加</el-button
    >
    <el-table :data="tableData" style="width: 100%">
      <el-table-column prop="id" label="ID" width="100"> </el-table-column>
      <el-table-column prop="name" label="任务名"> </el-table-column>
      <el-table-column prop="terminalNumber" label="设备id"> </el-table-column>
      <el-table-column prop="volume" label="音量"> </el-table-column>
      <el-table-column prop="times" label="循环次数"> </el-table-column>
      <el-table-column prop="edit" label="播放媒体列表" width="250" align="center">
        <template slot-scope="scope">
          <el-button
            size="small"
            type="primary"
            @click="(dialogMediaList = true), mediaListBox(scope.row.id)"
            round
          >
            <font v-if="scope.row.ste">修改</font>
            <font v-else>设置</font>
          </el-button>
        </template>
      </el-table-column>
      <el-table-column
        prop="edit"
        label="设置循环次数"
        width="250"
        align="center"
      >
        <template slot-scope="scope">
          <el-button
            size="small"
            type="primary"
            @click="(dialogTimes = true), openTimesWin(scope.row)"
            round
            >设置</el-button
          >
        </template>
      </el-table-column>
      <el-table-column prop="edit" label="设置音量" width="250" align="center">
        <template slot-scope="scope">
          <el-button
            size="small"
            type="primary"
            @click="(dialogVolume = true), openVolumeWin(scope.row)"
            round
            >设置</el-button
          >
        </template>
      </el-table-column>
      <el-table-column prop="edit" label="音乐播放" width="250" align="center">
        <template slot-scope="scope">
          <el-button
            size="small"
            type="primary"
            @click="StartMusic(scope.row)"
            round
            >播放</el-button
          >
          <el-button
            size="small"
            type="info"
            @click="OverMusic(scope.row)"
            round
            >关闭</el-button
          >
        </template>
      </el-table-column>
      <el-table-column prop="edit" label="编辑" width="100">
        <template slot-scope="scope">
          <div class="edit-button">
            <i
              @click="openEditWin(scope.row)"
              class="el-icon-edit pointer mar-r10"
            ></i>
            <i
              class="el-icon-delete pointer"
              @click="delItem(scope.row.id)"
            ></i>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="pageInfo.page"
      :page-sizes="[10, 20, 30, 40, 50, 100]"
      :page-size="pageInfo.pageSize"
      layout="sizes, total, prev, pager, next, jumper"
      :total="cnt_all"
    >
    </el-pagination>

    <!--新增对话框-->
    <el-dialog
      custom-class="mw-edit-dialog"
      class="dialog600"
      :title="editType === 'create' ? '添加广播任务' : '修改广播任务'"
      :visible.sync="dialogVisible"
      v-if="dialogVisible"
    >
      <el-form
        :model="editOne"
        label-position="left"
        label-width="100px"
        :rules="editOneRule"
      >
        <div class="user-info">
          <el-form-item label="任务名" prop="name">
            <el-input v-model="editOne.name"></el-input>
          </el-form-item>

          <el-form-item label="设备终端编号" prop="terminal_number_arr">
            <el-select
              placeholder="请选择设备终端编号"
              multiple
              v-model="editOne.terminal_number_arr"
              style="width: 100%"
            >
              <el-option
                v-for="t in devSelect"
                :key="t.value"
                :label="t.label"
                :value="t.value"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="音量" prop="volume">
            <el-input-number
              v-model="editOne.volume"
              size="small"
              :min="0"
              :max="100"
              :step="5"
            ></el-input-number>
          </el-form-item>
          <el-form-item label="次数" prop="times">
            <el-input-number
              v-model="editOne.times"
              size="small"
              :min="1"
            ></el-input-number>
          </el-form-item>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false"
          >取消</el-button
        >
        <el-button
          type="primary"
          @click="createItem"
          v-if="editType === 'create'"
          >确 定</el-button
        >
        <el-button
          type="primary"
          @click="updateItem"
          v-if="editType === 'update'"
          >确 定</el-button
        >
      </div>
    </el-dialog>

    <!--设置音量-->
    <el-dialog
      class="dialog400"
      v-if="dialogVolume"
      title="设置音量"
      :visible.sync="dialogVolume"
    >
      <el-form
        :model="editVolume"
        label-position="left"
        label-width="80px"
        :rules="editVolumeRule"
        ref="setVolume"
      >
        <el-form-item label="音量" prop="volume">
          <el-input v-model="editVolume.volume"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVolume = false"
          >取消</el-button
        >
        <el-button type="primary" @click="setVolume"
          >确 定</el-button
        >
      </div>
    </el-dialog>

    <!--设置循环次数-->
    <el-dialog
      class="dialog400"
      v-if="dialogTimes"
      title="设置循环次数"
      :visible.sync="dialogTimes"
    >
      <el-form
        :model="editTimes"
        label-position="left"
        label-width="80px"
        :rules="editTimeRule"
        ref="timesForm"
      >
        <el-form-item label="循环次数" prop="times">
          <el-input v-model="editTimes.times"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogTimes = false"
          >取消</el-button
        >
        <el-button type="primary" @click="setTimes"
          >确 定</el-button
        >
      </div>
    </el-dialog>

    <!--设置媒体库-->
    <el-dialog
      v-if="dialogMediaList"
      title="实时广播音乐列表"
      :visible.sync="dialogMediaList"
    >
      <dalog-media-list :nowId="nowId"></dalog-media-list>
    </el-dialog>
  </div>
</template>

<script>
import autoListApi from "@/api/audio/audioList";
import realtimeApi from "@/api/audio/realtime";
import dalogMediaList from '@/components/audio/realtime/dalogMediaList.vue'
export default {
  components:{ 
    dalogMediaList
  },
  data() {
    return {
      loading: false,
      dialogVisible: false,
      dialogVolume: false,
      dialogTimes: false,
      dialogMediaList: false,
      tableData: [],
      pageInfo: {
        page: 1,
        pageSize: 20,
      },
      cnt_all: 0,

      nowId: Number,
      editOneRule: {
        name: [{ required: true, message: "请输入任务名", trigger: "blur" }],
      },
      editVolumeRule: {
        volume: [{ required: true, message: "请输入声音", trigger: "blur" }],
      },
      editTimeRule: {
        times: [
          {
            required: true,
            message: "请输入循环次数",
            trigger: "blur",
          }
        ],
      },
      editType: -1,
      cnt_all: 0,
      pages: {
        page: 1,
        pageSize: 20,
      },
      devSelect: [],
      editOne: {
        name: "",
        volume: 0,
        times: 0,
        terminal_number: "",
        terminal_number_arr: [],
      },
      editVolume: {
        task_id: null,
        volume: 0,
      },
      editTimes: {
        task_id: null,
        times: 0,
      }
    };
  },
  methods: {
    getTableData(pageIndex) {
      // 获取任务列表
      this.pageInfo.page = pageIndex;
      this.loading = true;
      realtimeApi.realtimeList(this.pageInfo).then((res) => {
        if (res.data.code === 1000) {
          this.loading = false;
          let resData = res.data.data;
          this.tableData = resData.list;
          this.pageInfo.page = pageIndex;
          this.cnt_all = parseInt(resData.count);
          this.audioDeviceList();
        }
      });
    },

    handleSizeChange(val) {
      this.pageInfo.pageSize = val
      this.getTableData(this.pageInfo.page)
    },
    handleCurrentChange(val) {
      this.pageInfo.page = val
      this.getTableData(this.pageInfo.page)
    },
    openEditWin(index) {
      if (index === "create") {
        this.editOne = {
          name: "",
          volume: 0,
          times: 0,
          terminal_number: "",
          terminal_number_arr: [],
        };
        this.editType = "create";
      } else {
        this.editOne = {
          id: index.id,
          name: index.name,
          volume: index.volume,
          times: index.times,
          terminal_number: index.terminalNumber,
          terminal_number_arr: [],
        };
        this.editType = "update"
      }
      this.dialogVisible = true;
    },
    openVolumeWin(index) {
      //设置音量
      this.editVolume.task_id = index.id;
      this.editVolume.volume = index.volume;
      this.dialogVolume = true;
    },
    openTimesWin(index) {
      //设置循环次数
      this.editTimes.task_id = index.id;
      this.editTimes.times = index.times;
      this.dialogTimes = true;
    },
    mediaListBox(index) {
      //弹出列表
      this.dialogMediaList = true;
      this.nowId = index;
    },
    updateItem() {
      console.log('updateItem',this.editOne)
      let devId_arr = this.editOne.terminal_number_arr;
      let devId_str;
      if (devId_arr.length < 2) {
        devId_str = devId_arr[0] + "|";
      } else {
        devId_str = devId_arr.join("|");
      }
      this.editOne.terminal_number = devId_str;
      //音频名
      realtimeApi.realtimeEdit(this.editOne.id, this.editOne).then((res) => {
        if (res.data.code === 1000) {
          this.$message.success("修改成功");
          this.dialogVisible = false;
          this.getTableData(this.pageInfo.page);
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    createItem() {

      let devId_arr = this.editOne.terminal_number_arr;
      let devId_str;
      if (devId_arr.length < 2) {
        devId_str = devId_arr[0] + "|";
      } else {
        devId_str = devId_arr.join("|");
      }
      this.editOne.terminal_number = devId_str;

      realtimeApi.realtimeAdd(this.editOne).then((res) => {
        if (res.data.code === 1000) {
          this.$message.success("添加成功");
          this.dialogVisible = false;
          this.getTableData(this.pageInfo.page);
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    delItem(id) {
      this.$confirm("本操作将永久删除该条信息，是否继续？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
      .then(() => {
        realtimeApi.realtimeDel(id).then((res) => {
          if (res.data.code === 1000) {
            this.$message.success("删除成功");
            this.getTableData(this.pageInfo.page);
          } else {
            this.$message.error(res.data.message);
          }
        });
      })
      .catch(() => {
        this.$message({
          type: "info",
          message: "已取消删除",
        });
      });
    },



    StartAudioLive(id) {
      this.$post("StartAudioLive", { id: id }).then((resp) => {
        console.log(res.data);
        if (res.data.code === 1000) {
          this.$message.success(res.data.msg);
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    OverAudioLive(id) {
      this.$post("OverAudioLive", { id: id }).then((resp) => {
        // console.log(res.data)
        if (res.data.code === 1000) {
          this.$message.success(res.data.msg);
        } else {
          this.$message.error(res.data.message);
        }
      });
    },

    setVolume() {
      this.$refs["setVolume"].validate((valid) => {
        if (valid) {
          realtimeApi.realtimeSetVolume(this.editVolume).then((res) => {
            this.$message.success(res.data.message);
            if (res.data.code === 1000) {
              this.dialogVolume = false;
              this.getTableData(this.pageInfo.page);
            }
          });
        }
      });
    },

    setTimes() {
      this.$refs["timesForm"].validate((valid) => {
        if (valid) {
          realtimeApi.realtimeSetTimes(this.editTimes).then((res) => {
            this.$message.success(res.data.message);
            if (res.data.code === 1000) {
              this.dialogTimes = false;
              this.getTableData(this.pageInfo.page);
            }
          });
        }
      });
    },

    StartMusic(row) {
      realtimeApi.realtimeSetOn({
        task_id: row.id
      }).then((res) => {
        this.$message.success(res.data.message);
        if (res.data.code === 1000) {
          this.getTableData(this.pageInfo.page);
        }
      });
    },
    OverMusic(row) {
      realtimeApi.realtimeSetClose({
        task_id: row.id
      }).then((res) => {
        this.$message.success(res.data.message);
        if (res.data.code === 1000) {
          this.getTableData(this.pageInfo.page);
        }
      });
    },

    audioDeviceList() {
      // 获取所有的IP广播
      autoListApi
        .audioList({
          page: 1,
          pageSize: 200,
        })
        .then((res) => {
          if (res.data.code === 1000) {
            let resData = res.data.data.list;
            let devData = [];
            for (let i = 0; i < resData.length; i++) {
              let devobj = {
                value: resData[i].terminal_number,
                label:resData[i].terminal_number + "[" + resData[i].lamp_name + "]",
              };
              devData[i] = devobj;
            }
            this.devSelect = devData;
          } else {
            this.$message.error(res.data.message);
          }
        });
    },
  },
  mounted() {
    this.getTableData(this.pageInfo.page);
  },
};
</script>
<style lang='less' scoped>
.audio-content {
  width: 100%;
}
</style>